List of saved views.
<br>


<ag-grid-angular
    style="width: 100%; height: 300px;"
    class="ag-theme-balham"
    
    [rowData]="listOfSavedReports"
    [columnDefs]="contractColumns"
    (gridReady)="onGridReady($event)"
    (cellClicked)="onCellClicked($event)"
    >
</ag-grid-angular>



<!-- {{data | json }} -->


<!-- <h1 mat-dialog-title>Hi {{data.name}}</h1>
<div mat-dialog-content>
  <p>What's your favorite animal?</p>
  <mat-form-field>
    <input matInput [(ngModel)]="data.animal">
  </mat-form-field>
</div>
<div mat-dialog-actions>
  <button mat-button (click)="onNoClick()">No Thanks</button>
  <button mat-button [mat-dialog-close]="data.animal" cdkFocusInitial>Ok</button>
</div> -->